import * as React from 'react';

import { breakpoints } from '@notino/react-styleguide';

import { useReviewFromCache } from '@lib/reviews/ReviewPhotoModal/hooks';
import { useReviewPhotoModalStore } from '@lib/reviews/ReviewPhotoModal/store';
import { styled } from '@linaria/react';

const Wrapper = styled.div`
  display: flex;
  gap: 0.5rem;
  overflow-x: auto;
  margin-bottom: 2rem;
  padding: 4px;

  @media (min-width: ${breakpoints.md}) {
    overflow-x: unset;
    flex-wrap: wrap;
    margin-bottom: 0;
  }
`;

const Thumb = styled.img<{ active: boolean }>`
  height: 56px;
  width: 56px;
  min-width: 56px;
  object-fit: cover;
  border-radius: 3px;
  cursor: pointer;

  box-shadow: ${({ active }) =>
    active
      ? '0px 0px 0px 2px rgba(255, 255, 255, 1), 0px 0px 0px 4px rgba(0, 0, 0, 1)'
      : 'none'};

  @media (min-width: ${breakpoints.md}) {
    height: 80px;
    width: 80px;
    min-width: 80px;
    border-radius: 4px;
  }
`;

export const Thumbs = () => {
  const reviewId = useReviewPhotoModalStore((x) => x.reviewId);
  const review = useReviewFromCache(reviewId);
  const selectedImage = useReviewPhotoModalStore((x) => x.selectedImage);
  const { setImage } = useReviewPhotoModalStore((x) => x.actions);

  if (!review?.images?.length) {
    return null;
  }

  return (
    <Wrapper>
      {review.images.map((image) => (
        <Thumb
          key={image.thumbnailUrl}
          src={image.thumbnailUrl ?? undefined}
          active={image.thumbnailUrl === selectedImage.thumbnailUrl}
          onClick={() => setImage(image)}
        />
      ))}
    </Wrapper>
  );
};
